import Script from 'next/script'
import React, { FC, useEffect } from 'react'
import cn from 'clsx'
import s from './AffirmPrice.module.css'
const AffirmPrice: FC<{ price: number }> = ({ price }) => {
  useEffect(() => {
    const loadAffirmScript = () => {
      const affirmScript = document.createElement('script')
      affirmScript.src = 'https://cdn1.affirm.com/js/v2/affirm.js'
      affirmScript.async = true
      affirmScript.onload = () => {
        if (window.Affirm) {
          window.Affirm.ui.config({
            public_api_key: `${process.env.NEXT_PUBLIC_SPREE_API_KEY_AFFIRM}`,
            script: 'https://cdn1.affirm.com/js/v2/affirm.js',
          })
        }
      }
      document.head.appendChild(affirmScript)
    }
    loadAffirmScript()
    window.Affirm && window.Affirm.ui.refresh()
  }, [price])

  return (
    <div className="div">
      <Script
        id="affirm"
        dangerouslySetInnerHTML={{
          __html: `  
          _affirm_config = {
            public_api_key:   '${process.env.NEXT_PUBLIC_SPREE_API_KEY_AFFIRM}',
            script:          "https://cdn1.affirm.com/js/v2/affirm.js"
          };
          (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready" );
          `,
        }}
      />
      <p
        className={cn(s.text, 'affirm-as-low-as')}
        data-page-type="product"
        data-amount={price * 100}
      ></p>
    </div>
  )
}

export default AffirmPrice
